import { Inject, LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { CURRENT_LANG, FORM_ERROR_LIST, FORM_ERROR_LOCALIZATION, LOCALIZATION_DATA, LOCALIZATION_DATA_LIST, } from './token';
import { LocalizationCustomPipe } from './localization-custom.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { TranslatePipe } from './translate.pipe';
import { FormErrorLocalizationPipe } from './form-error-localization.pipe';
import { LocalizationService } from './localization.service';
import { Locales } from './locales';
import { FORMS_LOCALIZATION } from './forms.localization';
import { CityNamePipe } from './city-name.pipe';

type LocalizationData = { [key: string]: string };
type RootLocalization = { [key: string]: LocalizationData };

@NgModule({
  imports: [CommonModule],
  declarations: [
    TranslatePipe,
    LocalizationCustomPipe,
    FormErrorLocalizationPipe,
    DateFormatPipe,
    CityNamePipe,
  ],
  exports: [
    TranslatePipe,
    LocalizationCustomPipe,
    FormErrorLocalizationPipe,
    DateFormatPipe,
    CityNamePipe,
  ],
  providers: [
    LocalizationService,
    {
      provide: FORM_ERROR_LIST,
      useFactory: formErrorLocalizationFactory,
      deps: [
        FORM_ERROR_LOCALIZATION,
        [new SkipSelf(), new Optional(), new Inject(FORM_ERROR_LIST)],
      ],
    },
    {
      provide: LOCALIZATION_DATA_LIST,
      useFactory: localizationDataFactory,
      deps: [
        LOCALIZATION_DATA,
        [new SkipSelf(), new Optional(), new Inject(LOCALIZATION_DATA_LIST)],
      ],
    },
    {
      provide: FORM_ERROR_LOCALIZATION,
      useValue: FORMS_LOCALIZATION,
      multi: true,
    },
    {
      provide: LOCALIZATION_DATA,
      useValue: {},
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useFactory: initializeLang,
      deps: [LocalizationService, DOCUMENT],
    }
  ],
})
export class LocalizationModule {}

export function localizationDataFactory(newData: RootLocalization[], parent: RootLocalization) {
  const data = {...parent};
  for (const localeId of Object.values(Locales)) {
    for (const row of newData) {
      data[localeId] = {
        ...(data[localeId] || {}),
        ...row[localeId],
      };
    }
  }
  return data;
}

export function formErrorLocalizationFactory(newData: RootLocalization[], parent: RootLocalization) {
  const data = {...parent};
  for (const localeId of Object.values(Locales)) {
    for (const row of newData) {
      data[localeId] = {
        ...(data[localeId] || {}),
        ...row[localeId],
      };
    }
  }
  return data;
}

export function initializeLang(localizationService: LocalizationService, document: Document) {
  if (document.location.hostname.endsWith('.mtgame-sports.com')) {
    localizationService.setLocale(Locales.en);
  } else {
    localizationService.setLocale(Locales.ru);
  }
  return localizationService.getLocale();
}
